import { jsxs as e, jsx as s } from "react/jsx-runtime";
import { c } from "../../commons.module-WJbJq_Wu.js";
import { c as l } from "../../clsx-OuTLNxxd.js";
import { Icon as m } from "../../Icon/Icon.js";
const b = "ExcursionAccessibilityLevel-module_container__Tcd0h",
  p = "ExcursionAccessibilityLevel-module_with-description__EYfXC",
  x = "ExcursionAccessibilityLevel-module_body__2rqIp",
  u = "ExcursionAccessibilityLevel-module_description__F1-zU",
  i = {
    container: b,
    withDescription: p,
    body: x,
    description: u
  },
  f = _ref => {
    let {
      icon: o,
      label: r,
      description: n,
      showDescription: t = !1,
      titleClassName: a = void 0,
      title: d
    } = _ref;
    return /* @__PURE__ */e("div", {
      className: l(c.boxContainer, i.container, {
        [i.withDescription]: t
      }),
      children: [/* @__PURE__ */s("div", {
        className: l(c.boxTitle, a),
        children: d
      }), /* @__PURE__ */e("div", {
        className: i.body,
        children: [o && /* @__PURE__ */s(m, {
          name: o,
          className: i.icon,
          size: "1.5x",
          padding: !1
        }), /* @__PURE__ */e("div", {
          className: c.boxLabel,
          children: [r, t && n ? /* @__PURE__ */e("span", {
            className: i.description,
            children: [/* @__PURE__ */s("br", {}), n]
          }) : null]
        })]
      })]
    });
  };
export { f as ExcursionAccessibilityLevel, f as default };